module.exports = __webpack_public_path__ + "static/media/filter.669edc8e.svg";